import { Component, ViewChild } from '@angular/core';
import { AlertController, ModalController, NavController, ItemReorderEventDetail, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';

import { Stylist } from '../../models/stylist/stylist.model';
import { StylistService } from '../../services/stylist.service';
import { UserService } from '../../services/user.service';
import { StylistCreatePage } from '../stylist-create/stylist-create.page';
import { List } from 'immutable';
import { AlertService } from '../../utilities/alert.service';
import { ModalService } from '../../utilities/modal.service';

import { IonReorderGroup } from '@ionic/angular';

import { NavigationStateService } from '../../services/navigation-state.service';
/*@IonicPage({
  name: 'StylistManagerPage',
  segment: 'settings/staff',
  defaultHistory: ["SettingListPage"]
})*/

@Component({
  selector: 'app-stylist-manager',
  templateUrl: './stylist-manager.page.html',
  styleUrls: ['./stylist-manager.page.scss'],
})
export class StylistManagerPage {

  public isLoading: boolean = true;

  public errorOccurredWhileLoadingStylists: boolean = false;

  public stylists: List<Stylist> = List([]);

  public activeStylists: List<Stylist> = List([]);

  public inActiveStylists: List<Stylist> = List([]);

  public defaultStylistPhoto: string;

  public stylistsWithCalendarNum: number;

  @ViewChild(IonReorderGroup) reorderGroup: IonReorderGroup;

  constructor(private navCtrl: NavController,
    public userService: UserService,
    private alertController: AlertController,
    private readonly alertService: AlertService,
    private stylistService: StylistService,
    private toastController: ToastController,
    private modalController: ModalController,
    private router: Router,
    private readonly modalService: ModalService,
    public toastCtrl: ToastController,
    private navigationStateService: NavigationStateService) {


    this.isLoading = true;
    this.defaultStylistPhoto = Stylist.getDefaultProfilePic();
  }

  public ionViewWillEnter() {
    this.loadStaff();
  }

  public ionViewCanEnter() {


    if (!this.userService.getUser().isAdministrator()) {
      setTimeout(() => {
        this.router.navigate(['/settings/stylist-profile/']);
        // this.navCtrl.setRoot("SettingListPage");
        // this.navCtrl.push("StylistProfilePage");
      }, 100);
      return false;
    }

    return true;
  }

  public loadStaff() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylists = false;
    this.stylistService.setOutdated();
    this.stylistService.getStylists()
      .subscribe({
        next: (stylists) => {
          this.stylists = stylists;
          this.inActiveStylists = this.stylists.filter(stylist => stylist.active == 0).sort((a, b) => { return (a.sort - b.sort) });
          this.activeStylists = this.stylists.filter(stylist => stylist.active == 1).sort((a, b) => { return (a.sort - b.sort) });;
          this.stylistsWithCalendarNum = this.stylists.filter(stylist => stylist.active == 1 && stylist.calendar == 1).count();
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStylists = true;
        },
        complete: () => console.info('Fetched all stylists')
      });
  }

  public onStylistSelect(stylist: Stylist) {
    this.navigationStateService.setState({
      stylistID: stylist.getID(),
    });
    this.router.navigate(['/settings/stylist-profile/', stylist.getID()]);
  }
  public async addStaffMember() {

    if (!this.isAllowedToAddStaffMember()) {

      // TODO: 
      // this.alertController.create({title: 'salonMonster Account', message: `Your account has reached its maximum staff limit. You can upgrade your plan to add another staff member.`, buttons: ["Ok"]}).present();
      this.alertService.presentErrorAlert('Your account has reached its maximum staff limit. You can upgrade your plan to add another staff member.');
      return;
    }

    const maxSortVal = this.stylists?.max(x => x.sort).sort;
    const modal = await this.modalController.create({
      component: StylistCreatePage,
      componentProps: {
        sortVal: maxSortVal + 1 ?? 0,
      },
      backdropDismiss: false

    });
    // this.modalService.presentModal("StylistChangePasswordFormPage",{});

    modal.onDidDismiss().then((stylist) => {
      if (stylist) {
        this.loadStaff();
      }
    });

    await modal.present();
  }

  public isAllowedToAddStaffMember(): boolean {
    const planID: number = this.userService.getSalon().getPlanID();

    if ((planID === 2 || planID === 7) && this.stylistsWithCalendarNum < 1) {

      // freeplan || solo plan with 1 staff member
      return true;
    } else if ((planID === 3 || planID === 8) && this.stylistsWithCalendarNum < 5) {

      // small plan with 2 - 5 staff members
      return true;
    } else if ((planID === 4 || planID === 9) && this.stylistsWithCalendarNum < 10) {

      // medium plan with 6 - 10 staff members
      return true;
    } else if (planID === 5 || planID === 6 || planID === 10) {

      // large plan with unlimited staff
      return true;
    } else {
      return false;
    }

  }


  handleReorder(ev: CustomEvent<ItemReorderEventDetail>) {
    let stylists = this.activeStylists.toArray()
    stylists = ev.detail.complete(stylists);
    this.activeStylists = List(stylists);
    stylists.forEach((stylist: Stylist, index) => {
      stylist = stylist.setSort(index)
      this.stylistService.saveStylist(stylist).subscribe({
        next: async res => {
          const toast = await this.toastCtrl.create({
            message: 'New staff order saved',
            duration: 300,
            position: 'bottom'
          })
          toast.present();

        }, error: err => { console.error(err) }
      })
    })
  }
}
